import * as React from 'react';

export const Tasks = props => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.92659 3.75C9.59164 3.75 9.32031 4.02133 9.32031 4.35627V4.92933C9.32031 5.26428 9.59164 5.53561 9.92659 5.53561H14.5733C14.9083 5.53561 15.1796 5.26428 15.1796 4.92933V4.35627C15.1796 4.02133 14.9083 3.75 14.5733 3.75H9.92659ZM7.82031 4.35627C7.82031 3.1929 8.76321 2.25 9.92659 2.25H14.5733C15.7367 2.25 16.6796 3.1929 16.6796 4.35627V4.92933C16.6796 6.09271 15.7367 7.03561 14.5733 7.03561H9.92659C8.76321 7.03561 7.82031 6.09271 7.82031 4.92933V4.35627Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.57097 5.34375C6.91185 5.34375 5.56641 6.6892 5.56641 8.34831V17.2458C5.56641 18.9049 6.91185 20.2504 8.57097 20.2504H15.9303C17.5894 20.2504 18.9348 18.9049 18.9348 17.2458V8.34831C18.9348 6.6892 17.5894 5.34375 15.9303 5.34375C15.516 5.34375 15.1803 5.00796 15.1803 4.59375C15.1803 4.17954 15.516 3.84375 15.9303 3.84375C18.4178 3.84375 20.4348 5.86077 20.4348 8.34831V17.2458C20.4348 19.7334 18.4178 21.7504 15.9303 21.7504H8.57097C6.08343 21.7504 4.06641 19.7334 4.06641 17.2458V8.34831C4.06641 5.86077 6.08343 3.84375 8.57097 3.84375C8.98518 3.84375 9.32097 4.17954 9.32097 4.59375C9.32097 5.00796 8.98518 5.34375 8.57097 5.34375Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0561 14.3837C11.349 14.6766 11.349 15.1515 11.0561 15.4444L9.57339 16.9271C9.2805 17.22 8.80562 17.22 8.51273 16.9271L7.75092 16.1653C7.45803 15.8724 7.45803 15.3976 7.75092 15.1047C8.04381 14.8118 8.51869 14.8118 8.81158 15.1047L9.04306 15.3362L9.99548 14.3837C10.2884 14.0908 10.7633 14.0908 11.0561 14.3837Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0561 9.53608C11.349 9.82897 11.349 10.3038 11.0561 10.5967L9.57339 12.0795C9.2805 12.3724 8.80562 12.3724 8.51273 12.0795L7.75092 11.3177C7.45803 11.0248 7.45803 10.5499 7.75092 10.257C8.04381 9.96413 8.51869 9.96413 8.81158 10.257L9.04306 10.4885L9.99548 9.53608C10.2884 9.24318 10.7633 9.24318 11.0561 9.53608Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3809 16.2891C12.3809 15.8748 12.7166 15.5391 13.1309 15.5391H16.218C16.6322 15.5391 16.968 15.8748 16.968 16.2891C16.968 16.7033 16.6322 17.0391 16.218 17.0391H13.1309C12.7166 17.0391 12.3809 16.7033 12.3809 16.2891Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3809 11.4414C12.3809 11.0272 12.7166 10.6914 13.1309 10.6914H16.218C16.6322 10.6914 16.968 11.0272 16.968 11.4414C16.968 11.8556 16.6322 12.1914 16.218 12.1914H13.1309C12.7166 12.1914 12.3809 11.8556 12.3809 11.4414Z"
      fill="#64748B"
    />
  </svg>
);
